import * as network from './network';

// Get all components
const getAllComponents = (params) => {
  return network.get(`api/components`, params, true);
};

// Get single component by key
const getComponentByKey = (componentKey) => {
  return network.get(`api/components/${componentKey}`, {}, true);
};

// Get components by category
const getComponentsByCategory = (category) => {
  return network.get(`api/components/category/${category}`, {}, true);
};

export default {
  getAllComponents,
  getComponentByKey,
  getComponentsByCategory,
};
